import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import * as actions from '../redux/actions';
import Panel from './shared/Panel';
import CodeSnippet from './shared/CodeSnippet';
import { Divider } from 'semantic-ui-react';
import { getAllApis } from '../redux/reducers';
import { getCategories } from '../redux/reducers';
import ApiSingleDisplay from './APISingleDisplay';

import SubscriptionDescriptionTransaction from './SubscriptionDescriptionTransaction';
import SubscriptionDescriptionEvent from './SubscriptionDescriptionEvent';
import SubscriptionDescriptionHCS from './SubscriptionDescriptionHCS';
import SubscriptionSampleJava from './SubscriptionSampleJava';

import '../animate.css';

const SubscriptionPresentationPanel = (props) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { window.scrollTo(0, 0) }, [])

//   const fetchData = () => {
//     props.fetchApiList();
//     props.fetchApiCategories();
//   }

//   const apisFiltered = props.apis.filter(api => api.category === props.id);

//   const note1 = `Note: Your Access Key should be added to the request header "X-API-KEY,"`
//   const note2 = `e.g. in JavaScript request: `
//   const snippet = `headers: {'X-API-KEY': 'YOUR_ACCESS_KEY'}`

//   const apisToDisplay = apisFiltered.map(api => (
//     <ApiSingleDisplay key={api.id} apiId={api.id} url={api.url} shortDescription={api.title} longDescription={api.description} sample_url={api.sample_url}/>
//   ))

  const contentToDisplay = {
      "Transaction": <div><SubscriptionDescriptionTransaction /></div>,
      "Event": <div><SubscriptionDescriptionEvent /></div>,
      "HCS_Topic": <div><SubscriptionDescriptionHCS /></div>,
      "Sample Client Java Code": <div><SubscriptionSampleJava /></div>
  }

  return (
    <Panel
      title={
        <Fragment>
          {props.title}
          {/* <div style={{marginTop: "20px", fontSize: "70%"}}><span className="text-red">* </span>{note1}<br/>&nbsp;&nbsp;&nbsp;{note2}</div>
          <CodeSnippet style={{padding: '0 0 0 10px', marginBottom: '-15px'}}>{snippet}</CodeSnippet> */}
        </Fragment>
      }
      description=""
    >
      <Divider />
      <div>
        { contentToDisplay[props.title] }
      </div>
    </Panel>
  );
}

const mapStateToProps = (state) => ({
  apis: getAllApis(state),
  categories: getCategories(state)
});

export default connect(mapStateToProps, actions)(SubscriptionPresentationPanel);